<template>
  <transition name="popup">
    <div v-if="popupList.length" class="popup-mask">
      <div class="popup-wrapper" v-for="pop in popupList" :key="pop.index">
        <Loading :show="loading" type="popup">
          <component ref="popup" :is="pop.type" :option="pop" class="popup-container"
          @close="closeHandler" @submit="submitHandler" @loading="changeLoading"/>
        </Loading>
      </div>
    </div>
  </transition>
</template>

<script>
import Loading from '@/components/base/Loading.vue'
import UiconPopup from '@/components/popup/UiconPopup.vue'
import LinkPopup from '@/components/popup/LinkPopup.vue'
import EpubInfo from '@/components/popup/EpubInfo.vue'
import DriveList from '@/components/popup/DriveList.vue'
import CertPopup from '@/components/popup/CertPopup.vue'
import ChangeAccount from '@/components/popup/ChangeAccount.vue'
import PointBuy from '@/components/popup/PointBuy.vue'
import PointWitherawal from '@/components/popup/PointWitherawal.vue'
import AdultPopup from '@/components/popup/AdultPopup.vue'
import UploadPost from '@/components/popup/UploadPost.vue'
import ChangeCategory from '@/components/popup/ChangeCategory.vue'
import ChangeWork from '@/components/popup/ChangeWork.vue'
import ChangeAdult from '@/components/popup/ChangeAdult.vue'
import LoginPopup from '@/components/popup/LoginPopup.vue'
import BuyPost from '@/components/popup/BuyPost.vue'
import SupportPopup from '@/components/popup/SupportPopup.vue'
import ReportPopup from '@/components/popup/ReportPopup.vue'
import ProofPopup from '@/components/popup/ProofPopup.vue'
import PublishingPopup from '@/components/popup/PublishingPopup.vue'
import BookPublicationDate from '@/components/popup/BookPublicationDate.vue'
import PublishingPostList from '@/components/popup/PublishingPostList.vue'
import InputPopup from '@/components/popup/InputPopup.vue'
import RadioSelect from '@/components/popup/RadioSelect.vue'
import AddrSearch from '@/components/popup/AddrSearch.vue'
import CsReport from '@/components/popup/CsReport.vue'
import PointBuyCancel from '@/components/popup/PointBuyCancel.vue'

import CoverPopup from '@/components/popup/edit/CoverPopup.vue'

import OpenImage from '@/components/popup/admin/OpenImage.vue'
import PublicationInfo from '@/components/popup/admin/PublicationInfo.vue'
import PublishingStore from '@/components/popup/admin/PublishingStore.vue'
import CreateEpub from '@/components/popup/admin/CreateEpub.vue'
import PublishingEdit from '@/components/popup/admin/PublishingEdit.vue'
import ReportList from '@/components/popup/admin/ReportList.vue'
import ReportMenu from '@/components/popup/admin/ReportMenu.vue'
import ContractPopup from '@/components/popup/admin/ContractPopup.vue'
import WithdrawalList from '@/components/popup/admin/WithdrawalList.vue'
import AdminPoint from '@/components/popup/admin/AdminPoint.vue'
import Notice from '@/components/popup/admin/Notice.vue'

var requireIndex = 0

export default {
  props: {},
  created () {},
  mounted () {
  },
  beforeDestroy () {
  },
  data () {
    return {
      popupList: [],
      loading: true
    }
  },
  name: 'popupcon',
  watch: {
    '$store.getters.popup': function (val) {
      if (val !== null) {
        if (this.popupList.length === 0) {
          document.addEventListener('keydown', this.inputKeyDownHandler)
        }
        val.index = requireIndex
        requireIndex++
        this.popupList.push(val)
        console.log('list', this.popupList)
        console.log('$refs', this.$refs)
        this.$store.commit('popup', true)
      }
    }
  },
  methods: {
    changeLoading (value) {
      console.log('popup loading', value)
      this.loading = value
    },
    closeHandler () {
      console.log('closeHandler')
      this.callback()(this.newEvent('popup', this, false))
    },
    submitHandler (returnParam) {
      console.log('submitHandler', returnParam)
      this.callback()(this.newEvent('popup', this, true, returnParam))
    },
    inputKeyDownHandler (e) {
      // console.log(e.keyCode, e.which)
      console.log('', this.isPopup)
      var p
      if (this.isPopup) {
        switch (e.keyCode || e.which) {
          // enter
          case 13 :
            p = this.popupList[this.popupList.length - 1]
            console.log('input enter1', p)
            console.log('input enter2', this.$refs.popup[this.$refs.popup.length - 1].enter)
            if (this.$refs.popup[this.$refs.popup.length - 1] && this.$refs.popup[this.$refs.popup.length - 1].submit &&
            this.$refs.popup[this.$refs.popup.length - 1].enter === false) {
              this.$refs.popup[this.$refs.popup.length - 1].submit()
              e.preventDefault()
            }
            // if (this.$refs['popup' + p.index].submit) {
            //   this.$refs['popup' + p.index].submit()
            // }

            break
          // esc
          case 27 :
            this.closeHandler()
            e.preventDefault()
            break
        }
      }
    },
    callback () {
      var p = this.popupList.pop()
      if (this.popupList.length === 0) {
        document.removeEventListener('keydown', this.inputKeyDownHandler)
        this.$store.commit('openPopup', null)
        this.$store.commit('popup', false)
      }
      console.log(p)
      return (p && p.callback) ? p.callback : function (bo) {}
    },
    getIndexRef (item) {
      return 'popup' + item.index
    }
  },
  computed: {
  },
  components: {
    Loading,
    UiconPopup,
    'linkpopup': LinkPopup,
    CoverPopup,
    EpubInfo,
    DriveList,
    CertPopup,
    ChangeAccount,
    PointBuy,
    PointBuyCancel,
    PointWitherawal,
    AdultPopup,
    UploadPost,
    ChangeCategory,
    ChangeWork,
    ChangeAdult,
    LoginPopup,
    BuyPost,
    SupportPopup,
    ReportPopup,
    ProofPopup,
    PublishingPopup,
    BookPublicationDate,
    PublishingPostList,
    InputPopup,
    OpenImage,
    RadioSelect,
    PublicationInfo,
    PublishingStore,
    PublishingEdit,
    CsReport,
    AddrSearch,
    CreateEpub,
    ReportList,
    ReportMenu,
    WithdrawalList,
    ContractPopup,
    Notice,
    AdminPoint
  }
}
</script>

<style scoped>
.loading {

}
.popup-mask {
  position: fixed;
  z-index: 100;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  transition: opacity .3s ease;
}
.popup-wrapper {
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  background-color: rgba(0, 0, 0, .5);
}
.popup-container {
  display: flex;
  flex-direction: column;
  min-width: 300px;
  margin: 0px auto;
  padding: 20px 30px;
  background-color: var(--bg-white);
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}
.popup-enter {
  opacity: 0;
}
.popup-leave-active {
  opacity: 0;
}
.popup-enter .popup-container,
.popup-leave-active .popup-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/components/popup/PopupCon.vue